import { create } from 'zustand';
export const useScanStore = create((set) => ({
    currentScan: null,
    scanHistory: [],
    isScanning: false,
    error: null,
    pendingGitHubImport: null,
    setCurrentScan: (scan) => set({ currentScan: scan }),
    addToHistory: (scan) => set((state) => ({
        scanHistory: [scan, ...state.scanHistory].slice(0, 50),
    })),
    clearHistory: () => set({ scanHistory: [] }),
    setError: (error) => set({ error }),
    setIsScanning: (isScanning) => set({ isScanning }),
    setPendingGitHubImport: (payload) => set({ pendingGitHubImport: payload }),
}));
